// import React from 'react';
// import Navbar from '../components/Navbar';
// import HlcFooter from '../components/HlcFooter';

// const CommercialPage = () => {
//   return (
//     <>
//     <Navbar />
//       {/* ================= HLC COMMERCIAL SPACES GRID ================= */}
//       <section style={{marginTop:100}} className="hlc-com-spaces">
//         {/* Section Head */}
//         <div className="hlc-com-head">
//           <h2>Commercial Lighting Solutions</h2>
//           <p>
//             Professional-grade lighting solutions engineered to deliver performance,
//             comfort and visual consistency across commercial environments.
//           </p>
//         </div>

//         {/* Grid */}
//         <div className="hlc-com-grid">
//           {/* Offices */}
//           <article className="com-card">
//             <div className="com-img">
//               <span className="com-tag">OFFICES</span>
//               <img 
//                 decoding="async" 
//                 src="https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/12/Office-Lighting.png" 
//                 alt="Office Lighting"
//               />
//             </div>
//             <div className="com-body">
//               <h3>Office Lighting</h3>
//               <p>Uniform, glare-free lighting designed to improve productivity and comfort.</p>
//               <ul>
//                 <li>Uniform lux levels</li>
//                 <li>Low glare &amp; eye comfort</li>
//                 <li>Energy-efficient solutions</li>
//               </ul>
//               <a 
//                 href="https://skyblue-mink-835304.hostingersite.com/Commercial-Lighting/offices" 
//                 className="com-cta"
//               >
//                 Explore Offices →
//               </a>
//             </div>
//           </article>

//           {/* Retail & Showrooms */}
//           <article className="com-card">
//             <div className="com-img">
//               <span className="com-tag">RETAIL</span>
//               <img 
//                 decoding="async" 
//                 src="https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/12/Retail-Lighting.png" 
//                 alt="Retail Lighting"
//               />
//             </div>
//             <div className="com-body">
//               <h3>Retail &amp; Showroom Lighting</h3>
//               <p>High-quality lighting that enhances product visibility and customer experience.</p>
//               <ul>
//                 <li>Accent &amp; display lighting</li>
//                 <li>True color rendering</li>
//                 <li>Modern fixture designs</li>
//               </ul>
//               <a 
//                 href="https://skyblue-mink-835304.hostingersite.com/Commercial-Lighting/retail-showrooms" 
//                 className="com-cta"
//               >
//                 Explore Retail →
//               </a>
//             </div>
//           </article>

//           {/* Hospitality */}
//           <article className="com-card">
//             <div className="com-img">
//               <span className="com-tag">HOSPITALITY</span>
//               <img 
//                 decoding="async" 
//                 src="https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/12/Hospitality-Lighting.png" 
//                 alt="Hospitality Lighting"
//               />
//             </div>
//             <div className="com-body">
//               <h3>Hospitality Lighting</h3>
//               <p>Elegant lighting solutions for hotels, restaurants and lounges.</p>
//               <ul>
//                 <li>Warm ambience lighting</li>
//                 <li>Decorative fixtures</li>
//                 <li>Energy-efficient LEDs</li>
//               </ul>
//               <a 
//                 href="https://skyblue-mink-835304.hostingersite.com/Commercial-Lighting/hospitality" 
//                 className="com-cta"
//               >
//                 Explore Hospitality →
//               </a>
//             </div>
//           </article>

//           {/* Educational Institutions */}
//           <article className="com-card">
//             <div className="com-img">
//               <span className="com-tag">EDUCATION</span>
//               <img 
//                 decoding="async" 
//                 src="https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/12/Educational-Lighting.png" 
//                 alt="Educational Lighting"
//               />
//             </div>
//             <div className="com-body">
//               <h3>Educational Institutions</h3>
//               <p>Comfortable and consistent lighting for classrooms and learning spaces.</p>
//               <ul>
//                 <li>Uniform illumination</li>
//                 <li>Reduced eye strain</li>
//                 <li>Long-life fixtures</li>
//               </ul>
//               <a 
//                 href="https://skyblue-mink-835304.hostingersite.com/Commercial-Lighting/education" 
//                 className="com-cta"
//               >
//                 Explore Education →
//               </a>
//             </div>
//           </article>
//         </div>
//       </section>

//       {/* ================= RESIDENTIAL LIGHTING HERO ================= */}
//       <section className="hlc-res-hero">
//         <div className="hlc-res-hero__inner">
//           <div className="hlc-res-hero__cta">
//             <a 
//               href="https://skyblue-mink-835304.hostingersite.com/shop/" 
//               className="btn-primary"
//             >
//               Explore Products
//             </a>
//             <a 
//               href="https://wa.me/923337244858" 
//               target="_blank" 
//               rel="noopener noreferrer"
//               className="btn-secondary"
//             >
//               WhatsApp Expert
//             </a>
//           </div>
//         </div>
//       </section>

//       <style jsx>{`
//         /* ================= COMMERCIAL SPACES ================= */
//         .hlc-com-spaces {
//           max-width: 1200px;
//           margin: 60px auto;
//           padding: 0 16px;
//           font-family: system-ui, Segoe UI, Roboto, sans-serif;
//         }

//         /* Head */
//         .hlc-com-head {
//           max-width: 720px;
//           margin-bottom: 40px;
//         }

//         .hlc-com-head h2 {
//           font-size: 30px;
//           margin: 0 0 6px;
//         }

//         .hlc-com-head p {
//           font-size: 15px;
//           color: #555;
//         }

//         /* Grid */
//         .hlc-com-grid {
//           display: grid;
//           grid-template-columns: repeat(2, 1fr);
//           gap: 30px;
//         }

//         /* Card */
//         .com-card {
//           background: #fff;
//           border: 1px solid #eee;
//           display: flex;
//           flex-direction: column;
//           transition: 0.3s;
//         }

//         .com-card:hover {
//           transform: translateY(-4px);
//           box-shadow: 0 18px 40px rgba(0, 0, 0, 0.08);
//         }

//         /* Image */
//         .com-img {
//           position: relative;
//         }

//         .com-img img {
//           width: 100%;
//           height: 300px;
//           object-fit: cover;
//         }

//         .com-tag {
//           position: absolute;
//           top: 14px;
//           left: 14px;
//           background: #141320;
//           color: #fff;
//           font-size: 12px;
//           padding: 6px 10px;
//           letter-spacing: 0.08em;
//         }

//         /* Body */
//         .com-body {
//           padding: 20px;
//         }

//         .com-body h3 {
//           font-size: 20px;
//           margin: 0 0 6px;
//         }

//         .com-body p {
//           font-size: 14px;
//           color: #555;
//           margin-bottom: 10px;
//         }

//         .com-body ul {
//           padding-left: 18px;
//           margin: 0 0 14px;
//         }

//         .com-body li {
//           font-size: 13px;
//           margin-bottom: 4px;
//           color: #444;
//         }

//         /* CTA */
//         .com-cta {
//           font-size: 13px;
//           font-weight: 800;
//           text-transform: uppercase;
//           letter-spacing: 0.12em;
//           color: #9b1f6c;
//           text-decoration: none;
//         }

//         .com-cta:hover {
//           color: #542757;
//         }

//         /* Responsive */
//         @media (max-width: 900px) {
//           .hlc-com-grid {
//             grid-template-columns: 1fr;
//           }

//           .com-img img {
//             height: 260px;
//           }
//         }

//         /* ================= RESIDENTIAL HERO ================= */
//         .hlc-res-hero__inner {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//         }

//         /* CTA */
//         .hlc-res-hero__cta {
//           display: flex;
//           gap: 14px;
//           flex-wrap: wrap;
//           justify-content: center;
//           align-items: center;
//           text-align: center;
//         }

//         /* Buttons */
//         .btn-primary,
//         .btn-secondary {
//           padding: 12px 22px;
//           font-weight: 800;
//           font-size: 14px;
//           text-decoration: none;
//           border-radius: 0;
//           border: 2px solid transparent;
//         }

//         /* Primary */
//         .btn-primary {
//           background: #9b1f6c;
//           color: #fff;
//           border-color: #9b1f6c;
//         }

//         .btn-primary:hover {
//           background: #7f1958;
//           border-color: #7f1958;
//         }

//         /* Secondary */
//         .btn-secondary {
//           background: #fff;
//           color: #9b1f6c;
//           border-color: #9b1f6c;
//         }

//         .btn-secondary:hover {
//           background: #9b1f6c;
//           color: #fff;
//         }

//         /* RESPONSIVE */
//         @media (max-width: 768px) {
//           .hlc-res-hero {
//             padding: 40px 16px 50px;
//           }
//         }
//       `}</style>
//       <div style={{height:50}}/>

//       <HlcFooter/>
//     </>
//   );
// };

// export default CommercialPage;


import React from 'react';
import Navbar from '../components/Navbar';
import HlcFooter from '../components/HlcFooter';
import { useNavigate } from 'react-router-dom';
import CommercialImg from '../assets/indoor/hlc-commercial-indoor-lighting.webp';

const CommercialPage = () => {
  const navigate = useNavigate();

  const handleSubcategoryClick = (subType) => {
    navigate('/product-by-application', {
      state: {
        category: 'Commercial Lighting',
        subcategory: subType,
        subcategoryDescription: `Explore the best ${subType} lighting products for commercial spaces.`,
      },
    });
  };

  return (
    <>
      <Navbar />

      {/* ================= HLC COMMERCIAL SPACES GRID ================= */}
      <section style={{ marginTop: 100 }} className="hlc-com-spaces">
        <div className="hlc-com-head">
          <h2>Commercial Lighting Solutions</h2>
          <p>
            Professional-grade lighting solutions engineered to deliver performance,
            comfort and visual consistency across commercial environments.
          </p>
        </div>

        {/* Grid */}
        <div className="hlc-com-grid">
          {/* Offices */}
          <article className="com-card">
            <div className="com-img">
              <span className="com-tag">OFFICES</span>
              <img 
                decoding="async" 
                src={CommercialImg}
                alt="Office Lighting"
              />
            </div>
            <div className="com-body">
              <h3>Office Lighting</h3>
              <p>Uniform, glare-free lighting designed to improve productivity and comfort.</p>
              <ul>
                <li>• Uniform lux levels</li>
                <li>• Low glare &amp; eye comfort</li>
                <li>• Energy-efficient solutions</li>
              </ul>
              <button 
                className="com-cta"
                onClick={() => handleSubcategoryClick('Offices')}
              >
                Explore Offices →
              </button>
            </div>
          </article>

          {/* Retail & Showrooms */}
          <article className="com-card">
            <div className="com-img">
              <span className="com-tag">RETAIL</span>
              <img 
                decoding="async" 
                src={CommercialImg}
                alt="Retail Lighting"
              />
            </div>
            <div className="com-body">
              <h3>Retail &amp; Showroom Lighting</h3>
              <p>High-quality lighting that enhances product visibility and customer experience.</p>
              <ul>
                <li>• Accent &amp; display lighting</li>
                <li>• True color rendering</li>
                <li>• Modern fixture designs</li>
              </ul>
              <button 
                className="com-cta"
                onClick={() => handleSubcategoryClick('Retail & Showrooms')}
              >
                Explore Retail →
              </button>
            </div>
          </article>

          {/* Hospitality */}
          <article className="com-card">
            <div className="com-img">
              <span className="com-tag">HOSPITALITY</span>
              <img 
                decoding="async" 
                src={CommercialImg}
                alt="Hospitality Lighting"
              />
            </div>
            <div className="com-body">
              <h3>Hospitality Lighting</h3>
              <p>Elegant lighting solutions for hotels, restaurants and lounges.</p>
              <ul>
                <li>• Warm ambience lighting</li>
                <li>• Decorative fixtures</li>
                <li>• Energy-efficient LEDs</li>
              </ul>
              <button 
                className="com-cta"
                onClick={() => handleSubcategoryClick('Hospitality')}
              >
                Explore Hospitality →
              </button>
            </div>
          </article>

          {/* Educational Institutions */}
          <article className="com-card">
            <div className="com-img">
              <span className="com-tag">EDUCATION</span>
              <img 
                decoding="async" 
                src={CommercialImg}
                alt="Educational Lighting"
              />
            </div>
            <div className="com-body">
              <h3>Educational Institutions</h3>
              <p>Comfortable and consistent lighting for classrooms and learning spaces.</p>
              <ul>
                <li>• Uniform illumination</li>
                <li>• Reduced eye strain</li>
                <li>• Long-life fixtures</li>
              </ul>
              <button 
                className="com-cta"
                onClick={() => handleSubcategoryClick('Educational Institutions')}
              >
                Explore Education →
              </button>
            </div>
          </article>
        </div>
      </section>

      {/* ================= COMMERCIAL HERO ================= */}
      <section className="hlc-res-hero">
        <div className="hlc-res-hero__inner">
          <div className="hlc-res-hero__cta">
            <a 
             onClick={()=>navigate('/shop')}
              className="btn-primary"
            >
              Explore Products
            </a>
            <a 
              href="https://wa.me/923337244858" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-secondary"
            >
              WhatsApp Expert
            </a>
          </div>
        </div>
      </section>

      <div style={{ height: 50 }} />

      <style jsx>{`
        .hlc-com-spaces { max-width: 1200px; margin: 60px auto; padding: 0 16px; font-family: system-ui, Segoe UI, Roboto, sans-serif; }
        .hlc-com-head { max-width: 720px; margin-bottom: 40px; }
        .hlc-com-head h2 { font-size: 30px; margin: 0 0 6px; }
        .hlc-com-head p { font-size: 15px; color: #555; }
        .hlc-com-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 30px; }
        .com-card { background: #fff; border: 1px solid #eee; display: flex; flex-direction: column; transition: 0.3s; }
        .com-card:hover { transform: translateY(-4px); box-shadow: 0 18px 40px rgba(0, 0, 0, 0.08); }
        .com-img { position: relative; }
        .com-img img { width: 100%; height: 300px; object-fit: cover; }
        .com-tag { position: absolute; top: 14px; left: 14px; background: #141320; color: #fff; font-size: 12px; padding: 6px 10px; letter-spacing: 0.08em; }
        .com-body { padding: 20px; }
        .com-body h3 { font-size: 20px; margin: 0 0 6px; }
        .com-body p { font-size: 14px; color: #555; margin-bottom: 10px; }
        .com-body ul { padding-left: 18px; margin: 0 0 14px; }
        .com-body li { font-size: 13px; margin-bottom: 4px; color: #444; }
        .com-cta { font-size: 13px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.12em; color: #9b1f6c; background: none; border: none; text-align: left; cursor: pointer; padding: 0; }
        .com-cta:hover { color: #542757; }
        @media (max-width: 900px) { .hlc-com-grid { grid-template-columns: 1fr; } .com-img img { height: 260px; } }
        .hlc-res-hero__inner { display: flex; justify-content: center; align-items: center; }
        .hlc-res-hero__cta { display: flex; gap: 14px; flex-wrap: wrap; justify-content: center; align-items: center; text-align: center; }
        .btn-primary, .btn-secondary { padding: 12px 22px; font-weight: 800; font-size: 14px; text-decoration: none; border-radius: 0; border: 2px solid transparent; }
        .btn-primary { background: #9b1f6c; color: #fff; border-color: #9b1f6c; }
        .btn-primary:hover { background: #7f1958; border-color: #7f1958; }
        .btn-secondary { background: #fff; color: #9b1f6c; border-color: #9b1f6c; }
        .btn-secondary:hover { background: #9b1f6c; color: #fff; }
        @media (max-width: 768px) { .hlc-res-hero { padding: 40px 16px 50px; } }
      `}</style>

      <HlcFooter />
    </>
  );
};

export default CommercialPage;
